export const PaymentStates = Object.freeze({
  Successful: 'successful',
  Completed: 'completed',
  Failed: 'failed',
});

export default PaymentStates;
